import dayjs from 'dayjs'
import Link from 'next/link'
import styles from './ArticleCard.module.scss'
import { Article } from '../types'
import { useTranslation } from 'next-i18next/pages'
import classNames from 'classnames'
import { CmsArticleTypes } from 'types/cms/enums'
import { Heading, Icon, Img } from '@boltenergy-be/design-system'

const ArticleCard = ({ author, category, destination, extraClassNames, publishedAt, thumbnail, title, type, className }: Article) => {
  // i18n
  const { t } = useTranslation('common')

  return (
    <div className={className}>
      {type !== CmsArticleTypes.BLOG_EXTERNAL ? (
        <Link href={destination} className={classNames(styles['article-card'], extraClassNames)}>
          <figure className={styles['thumbnail-wrapper']}>
            {thumbnail && (
              <Img
                fill
                publicId={thumbnail.provider_metadata.public_id}
                alt={`${t('thumbnail', 'thumbnail')} ${title}`}
                className={styles.thumbnail}
                sizes="(max-width: 620px) 100vw, (max-width: 920px) 50vw, (max-width: 1120px) 33vw, 25vw"
              />
            )}
          </figure>
          <div className={styles.content}>
            {category && <small className="weight-bold">{category?.title}</small>}

            <Heading as="h4" serif>
              {title}
            </Heading>

            <small className={styles.author}>
              {dayjs(publishedAt).format('DD/MM/YYYY')} | {author.firstName}
            </small>
          </div>
        </Link>
      ) : (
        <a className={classNames(styles['article-card'], extraClassNames)} href={destination} target="_blank" rel="noreferrer noopener">
          {thumbnail && (
            <figure className={styles['thumbnail-wrapper']}>
              <Img
                fill
                publicId={thumbnail.provider_metadata.public_id}
                alt={`${t('thumbnail', 'thumbnail')} ${title}`}
                className={styles.thumbnail}
                sizes="(max-width: 620px) 100vw, (max-width: 920px) 50vw, (max-width: 1120px) 33vw, 25vw"
              />
            </figure>
          )}
          <div className={styles.content}>
            {category && <small className="weight-bold">{category?.title}</small>}

            <Heading as="h4" serif className={styles.title}>
              {title} <Icon name="externalLink" />
            </Heading>

            <small className={styles.author}>
              {dayjs(publishedAt).format('DD/MM/YYYY')} | {author.firstName}
            </small>
          </div>
        </a>
      )}
    </div>
  )
}

ArticleCard.defaultProps = {
  type: CmsArticleTypes.BLOG_INTERNAL
}

export default ArticleCard
